<div [class]="skinName">
    <div id="card-align2" [ngClass]="{'card-align2': (( !content_type || (content_type != 'article' && content_type != 'audio'  && content_type != 'article_series' && content_type != 'podcast'))) ,'article-align': (content_type == 'article' || content_type == 'article_series'), 'audio-align':  (content_type == 'audio' || content_type == 'podcast') }">
        @for(data of cardsData; track data){
            @if(!content_type || (content_type != 'article' && content_type != 'audio' && content_type != 'article_series' && content_type != 'podcast')){
                <div class="bg-cards">
                    <div class="card-img-align">
                        <div class="card-grad" (click)="redirect(data, $index)">
                            @if(type !== 'genreList' && !contentPartner && data?.poster_landscape){
                                <img class="card-img" loading="lazy" [src]="settingsService.getImage(data.poster_landscape, 'card')">
                            }
                            @if(type !== 'genreList' && contentPartner && data?.poster_landscape){
                                <img class="card-img" loading="lazy" [src]="settingsService.getImage(data.poster_landscape, 'card')">
                            }
                            @if(type === 'genreList'){
                                <img class="card-img" loading="lazy" [src]="settingsService.getImage(data.background_landscape, 'card')">
                            }
                            @if(!contentPartner && settingsService.enableModerators && data?.partnerLogo){
                                <span class="partner-logo">
                                    <img loading="lazy" [src]="settingsService.getImage(data?.partnerLogo, 'logo')" alt="" />
                                </span>
                            }
                            @if(currentPath != 'top_picks_for_you' && currentPath != 'because_you_watched'){
                                @if(data?.catchup){
                                    <span class="channel-card-logo">
                                    <img loading="lazy" [src]="settingsService.getImage(data.live_channel.content_logo, 'logo')"  alt="" />
                                    </span>
                                }
                                <div class="tvod-onair-logo">
                                    @if (data?.is_tvod) {
                                        <div class="tvod-info">
                                            @if (data?.isRented) {
                                            <img loading="lazy" src="/branding/theme/assets/static_assets/ic-expiry-icon-gold.svg" alt="">
                                            } @else {
                                            <img loading="lazy" src="/branding/theme/assets/static_assets/ic-tvod-new-tag.svg" alt="">
                                            }
                                        </div>
                                    }
                                    @if(data?.catchup){
                                        <span class="onair-card-logo">
                                            <img loading="lazy" src="/branding/theme/assets/static_assets/ic-catch-up-content-tag.svg" alt="">
                                        </span>
                                    }
                                </div>
                            }
                        </div>
                        <div (click)="redirect(data, $index)" [ngClass]="type === 'genreList' ? 'genre-img-gradient' : 'img-gradient'"></div>
                        @if(type === 'genreList'){
                            <div (click)="redirect(data, $index)" class="video-detail">
                                <p>{{data.title}}</p>
                                <a> {{configService?.localeKeys?.genre_card_view_content_desc || 'View Content'}} > </a>
                            </div>
                        }
                        @if(type !== 'genreList'){
                        <div class="meta-card">
                            @if(data?.publish_time){
                                <div class="publish-card ">{{data?.publish_time}}</div>
                            }
                            @if(data?.genre && genreCurationEnabled == 1){
                                <span class="pipe">|</span>
                                <span>{{configService?.localeKeys[data?.genre?.split(",")[0]]}}</span>
                            }
                            @if(data?.tags && genreCurationEnabled == 0){
                                <span class="pipe">|</span>
                                <span>{{data?.tags[0]}}</span>
                            }
                            @if(data?.is_series == 1){
                                <span>
                                    @if(data?.total_seasons){
                                        <span class="pipe">|</span>
                                    }
                                    @if(data?.total_seasons){
                                        <span class="text-style">{{data?.total_seasons}}
                                        {{configService.localeKeys?.['common_keys.seasons.text']}}
                                        </span>
                                    }
                                </span>
                            }
                            @if(data?.is_series == 0){
                                <span class="tags-section d-flex">
                                    @if(data?.duration_min){
                                        <span class="pipe">|</span>
                                    }
                                    @if(data?.duration_min){
                                        <span class="text-style">{{data?.duration_min | movieDuration}}</span>
                                    }
                                </span>
                            }
                        </div>
                        }
                        @if(type !== 'genreList' && !contentPartner){
                        <div class="actions-card">
                            <span class="actions-card-container">
                                @if(!(baseService.guest | async) || restrictedUser){
                                <span class="action-card-tooltip">
                                    <img (click)="dialog.closeAll();callingPlayContentServicePlay(data, $index ,'play')"
                                        class="cursor-pointer card-icon" src="branding/theme/assets/static_assets/ic-play-icon-on-card.svg">
                                    <span
                                        class="action-card-tooltip-text">{{configService?.localeKeys?.['player.play_video.btn']
                                        || 'Play'}}</span>
                                </span>}
                                @if(!data?.wishlist && !(baseService.guest | async) && !data?.is_livechannel &&
                                !restrictedUser){
                                <span class="action-card-tooltip">
                                    <img (click)="addToWishlist(data)" class="cursor-pointer card-icon"
                                        src="branding/theme/assets/static_assets/ic-empty-heart-on-lbg.svg">
                                    <span
                                        class="action-card-tooltip-text">{{configService?.localeKeys?.['my_list.pop_menu_list.text']
                                        || 'Add to wishlist'}}</span>
                                </span>}
                                @if(data?.wishlist && !(baseService.guest | async) && !data?.is_livechannel && !restrictedUser){
                                <span class="action-card-tooltip">
                                    <img (click)="removeFromWishlist(data)" class="cursor-pointer card-icon"
                                        src="branding/theme/assets/static_assets/ic-filled-heart-on-lbg.svg">
                                    <span class="action-card-tooltip-text">{{configService?.localeKeys?.['my_list.remove.text']
                                        || 'Remove from watchlist'}}</span>
                                </span>}
                                <span class="action-card-tooltip">
                                    <img (click)="redirect(data, $index)" class="cursor-pointer card-icon"
                                        src="branding/theme/assets/static_assets/ic-info-on-lbg.svg">
                                    <span class="action-card-tooltip-text">{{configService?.localeKeys?.see_info_title || 'See
                                        info'}}</span>
                                </span>
                            </span>
                        </div>
                        }
                    </div>
                    @if(type === 'genreList'){
                    <div class="title" id="details">
                        <div id="head">
                            <div id="title" class="text-hidden">{{data.title}}</div>
                        </div>
                    </div>
                    }
                    @if(type !== 'genreList'){
                    <div id="details">
                        <div id="head">
                            <div id="title" class="text-hidden">{{data.title}}</div>
                            @if(data.duration){
                            <div id="duration">
                                <div id="time">{{data?.duration_min | movieDuration}}</div>
                                <img id="clock" src="branding/theme/assets/static_assets/ic-time-on-lbg.svg">
                            </div>
                            }
                        </div>
                        <div id="footer">
                            <div id="description" class="text-vertical-hidden">
                                {{data.description}}
                            </div>
                        </div>
                    </div>
                    }
                </div>
            }
            @if(content_type && (content_type == 'audio' || content_type == 'podcast')){
                <div class="audio-card-container" (click)="redirect(data, $index)">
                    <img class="audio-card-img" [src]="settingsService.getImage(data.poster_square, 'card')">
                    @if(!contentPartner && settingsService.enableModerators && data?.partnerLogo){
                        <span class="partner-logo">
                            <img loading="lazy" [src]="settingsService.getImage(data?.partnerLogo, 'logo')" alt="" />
                        </span>
                    }
                    <div class="square-detail-area">
                        <span class="square-detail-area-title">{{data.title}}</span>
                        <span class="square-detail-area-cast">{{data.cast}}</span>
                    </div>
                </div>
            }
            @if(content_type && (content_type == 'article'  || content_type == 'article_series')){
                <div class="article-card-container" (click)="redirect(data, $index)">
                    <img class="article-card-img" [src]="settingsService.getImage(data.poster_portrait, 'card')">
                    @if(!contentPartner && settingsService.enableModerators && data?.partnerLogo){
                        <span class="partner-logo">
                            <img loading="lazy" [src]="settingsService.getImage(data?.partnerLogo, 'logo')" alt="" />
                        </span>
                    }
                    <div class="article-detail-area">
                        <span class="article-detail-area-title">{{data.title}}</span>
                    </div>
                </div>
            }
        }
    </div>
</div>